"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MODEL_TOKEN_CREDIT_RATES = void 0;
exports.creditsForTokenUsage = creditsForTokenUsage;
exports.MODEL_TOKEN_CREDIT_RATES = {
    'claude-opus-4-8': {
        inputPerMillion: 3,
        outputPerMillion: 15,
        cacheReadPerMillion: 0.3,
        cacheWritePerMillion: 3.75,
    },
};
function creditsForTokenUsage(tokens, model) {
    const rates = exports.MODEL_TOKEN_CREDIT_RATES[model];
    if (rates === undefined) {
        throw new Error(`No token credit rate is defined for model '${model}'`);
    }
    const uncachedInput = Math.max(0, tokens.inputTokens - tokens.cacheReadTokens - tokens.cacheWriteTokens);
    return ((uncachedInput * rates.inputPerMillion +
        tokens.cacheReadTokens * rates.cacheReadPerMillion +
        tokens.cacheWriteTokens * rates.cacheWritePerMillion +
        tokens.outputTokens * rates.outputPerMillion) /
        1_000_000);
}
//# sourceMappingURL=token-credit-formula.js.map